// extracted by mini-css-extract-plugin
export default {"report":"Reports_report__x+VKg","base":"Reports_base__L9lkz","header":"Reports_header__8t87F","controls":"Reports_controls__PUwe-"};